<template>
    <div>
        {{ realIndex }}
        <div class="columns is-vcentered">
            <div class="column is-narrow">
                <div class="field has-addons">
                    <p class="control">
                        <a
                            class="button"
                            :class="{'is-active': filter === 'all'}"
                            @click="filter = 'all'; changeFilter('all');"
                        >All</a>
                    </p>
                    <p class="control">
                        <a
                            class="button"
                            :class="{'is-active': filter === 'popular'}"
                            @click="filter = 'popular'; changeFilter('popular');"
                        >
                            <span class="icon is-small">
                                <i class="fas fa-star has-text-warning"></i>
                            </span>
                            <span>Popular</span>
                        </a>
                    </p>
                    <p class="control">
                        <a
                            class="button"
                            :class="{'is-active': filter === 'new'}"
                            @click="filter = 'new';changeFilter('new');"
                        >
                            <span class="icon is-small">
                                <i class="fas fa-fire has-text-danger"></i>
                            </span>
                            <span>New</span>
                        </a>
                    </p>
                </div>
            </div>
            <div v-if="selectedFilter.provider" class="column is-narrow">
                Provider:
                <span class="tag is-success">
                    {{ selectedFilter.provider }}
                    <button @click="deleteFilter('provider')" class="delete"></button>
                </span>
            </div>
            <div v-if="selectedFilter.category" class="column is-narrow">
                Category:
                <span class="tag is-success">
                    {{ selectedFilter.category }}
                    <button @click="deleteFilter('category')" class="delete"></button>
                </span>
            </div>
            <div v-if="selectedFilter.search" class="column is-narrow">
                Search:
                <span class="tag is-success">
                    {{ selectedFilter.search }}
                    <button @click="deleteFilter('search')" class="delete"></button>
                </span>
            </div>
            <div class="column is-narrow">
                Found games: {{ numOfGames ? numOfGames : 0 }}
            </div>
        </div>

        <table class="table is-fullwidth is-hoverable is-size-7">
            <thead>
                <tr v-if="filter == 'all' && games.length">
                    <th></th>
                    <th></th>
                    <th></th>
                    <th></th>
                    <th></th>
                    <th></th>
                    <th></th>
                    <th></th>
                    <th>
                        <div class="field has-addons">
                            <div class="control">
                                <button class="button is-small is-success" @click="toggleParametr(true, 'isEnabled')" :disabled="loading">Enable All</button>
                            </div>
                            <div class="control">
                                <button class="button is-small is-danger" @click="toggleParametr(false, 'isEnabled')" :disabled="loading">Disable All</button>
                            </div>
                        </div>
                    </th>
                    <th>
                        <div class="field has-addons">
                            <div class="control">
                                <button class="button is-small is-success" @click="toggleParametr(false, 'isHidden')" :disabled="loading">Show All</button>
                            </div>
                            <div class="control">
                                <button class="button is-small is-danger" @click="toggleParametr(true, 'isHidden')" :disabled="loading">Hide All</button>
                            </div>
                        </div>
                    </th>
                    <th>
                        <div class="field has-addons">
                            <div class="control">
                                <button class="button is-small is-success" @click="toggleParametr(true, 'useCache')" :disabled="loading">Cache On</button>
                            </div>
                            <div class="control">
                                <button class="button is-small is-danger" @click="toggleParametr(true, 'useCache')" :disabled="loading">Cache Off</button>
                            </div>
                        </div>
                    </th>
                    <th></th>
                    <th></th>
                    <th></th>
                </tr>
                <tr>
                    <th>#</th>
                    <th>Pop.</th>
                    <th>New</th>
                    <th>Category</th>
                    <th>Name</th>
                    <th>Image</th>
                    <th>Id</th>
                    <th>Priority</th>
                    <th>Is enabled</th>
                    <th>Is hidden</th>
                    <th>Use cache</th>
                    <th>Tags</th>
                    <th>Sub-category</th>
                    <th></th>
                </tr>
                <tr v-if="!numOfGames">
                    <div class="box">
                        <span class="tag is-danger">No games found</span>
                    </div> 
                </tr>
            </thead>
            <tbody>
                <template
                    v-for="(game, index) in uiGames"
                >
                    <tr
                        :key="`${game.gameId}-g`"
                        :class="{ 'is-selected': gameToEdit && gameToEdit.gameId === game.gameId }"
                    >
                        <td>{{realIndex + index + 1}}</td>
                        <td>
                            <span class="icon is-medium toggle"
                                  :class="{'has-text-warning':game.isPopular, 'has-text-grey-lighter':!game.isPopular}"
                                  @click="game.isPopular = !game.isPopular; save(game);">
                                <i class="fas fa-2x fa-star"></i>
                            </span>
                        </td>
                        <td>
                            <span class="icon is-medium toggle"
                                  :class="{'has-text-danger':game.isNew, 'has-text-grey-lighter':!game.isNew}"
                                  @click="game.isNew = !game.isNew; save(game);">
                                <i class="fas fa-2x fa-fire"></i>
                            </span>
                        </td>
                        <td>{{game.category}}</td>
                        <td>
                            <p v-if="game.name"><span v-if="game.displayName">Tech. name:</span> <span class="has-text-weight-bold">{{game.name}}</span></p>
                            <p v-if="game.displayName">Disp. name: {{game.displayName}}</p>
                            <p v-if="!game.name && !game.displayName">[no name]</p>
                        </td>
                        <td>
                            <img :src="game.thumbnailUrl" class="thumbnail" />
                        </td>
                        <td>
                            <p>{{game.gameId}}</p>
                            <p v-if="game.gameSourceProvider"
                               class="has-text-grey">{{game.gameSourceProvider}}</p>
                        </td>
                        <td>
                            <div class="field has-addons">
                                <div class="control">
                                    <input class="input is-small"
                                           type="number"
                                           placeholder="priority"
                                           v-model="game.priority" />
                                </div>
                                <div class="control">
                                    <a class="button is-info is-small" @click="save(game)">
                                        <span class="icon is-small">
                                            <i class="far fa-save"></i>
                                        </span>
                                    </a>
                                </div>
                            </div>
                        </td>
                        <td>
                            <span class="tag button-tag"
                                  :class="{'is-success':game.isEnabled, 'disabled':loading}"
                                  @click="game.isEnabled = true; save(game);">enabled</span>
                            <span class="tag button-tag"
                                  :class="{'is-danger':!game.isEnabled, 'disabled':loading}"
                                  @click="game.isEnabled = false; save(game);">disabled</span>
                        </td>
                        <td>
                            <span class="tag button-tag"
                                  :class="{'is-success':!game.isHidden, 'disabled':loading}"
                                  @click="game.isHidden = false; save(game);">visible</span>
                            <span class="tag button-tag"
                                  :class="{'is-danger':game.isHidden, 'disabled':loading}"
                                  @click="game.isHidden = true; save(game);">hidden</span>
                        </td>
                        <td>
                            <span class="tag button-tag"
                                  :class="{'is-success':game.useCache, 'disabled':loading}"
                                  @click="game.useCache = true; save(game);">enabled</span>
                            <span class="tag button-tag"
                                  :class="{'is-danger':!game.useCache, 'disabled':loading}"
                                  @click="game.useCache = false; save(game);">disabled</span>
                        </td>
                        <td>{{game.tags && game.tags.join(', ')}}</td>
                        <td>{{game.subCategory}}</td>
                        <td><a class="button is-small" @click="setGameToEdit(game)">Edit</a></td>
                    </tr>
                    <tr v-if="gameToEdit && gameToEdit.gameId === game.gameId" :key="`${game.gameId}-e`">
                        <td colspan="14">
                            <article class="message">
                                <div class="message-header">
                                    <p>{{gameToEdit.gameId}} <span v-if="gameToEdit.displayName"> / {{gameToEdit.displayName}}</span></p>
                                    <button class="delete" aria-label="delete" @click="setGameToEdit(null)"></button>
                                </div>
                                <div class="message-body">
                                    <!-- Id -->
                                    <div class="field is-horizontal">
                                        <div class="field-label is-normal">
                                            <label class="label">PaH db id</label>
                                        </div>
                                        <div class="field-body">
                                            <div class="field">
                                                <div class="control">
                                                    <input class="input oc-input" type="text" v-model="gameToEdit.id" readonly />
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <!-- GameId -->
                                    <div class="field is-horizontal">
                                        <div class="field-label is-normal">
                                            <label class="label">Prov. game id</label>
                                        </div>
                                        <div class="field-body">
                                            <div class="field">
                                                <div class="control">
                                                    <input class="input oc-input" type="text" v-model="gameToEdit.gameId" readonly />
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <!-- Name -->
                                    <div class="field is-horizontal">
                                        <div class="field-label is-normal">
                                            <label class="label">Name</label>
                                        </div>
                                        <div class="field-body">
                                            <div class="field">
                                                <div class="control">
                                                    <input class="input oc-input" type="text" v-model="gameToEdit.name" />
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <!-- DisplayName -->
                                    <div class="field is-horizontal">
                                        <div class="field-label is-normal">
                                            <label class="label">Display name</label>
                                        </div>
                                        <div class="field-body">
                                            <div class="field">
                                                <div class="control">
                                                    <input class="input oc-input" type="text" v-model="gameToEdit.displayName" />
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <!-- BackgroundUrl -->
                                    <div class="field is-horizontal">
                                        <div class="field-label is-normal">
                                            <label class="label">Background url</label>
                                        </div>
                                        <div class="field-body">
                                            <div class="field">
                                                <div class="control">
                                                    <input class="input oc-input" type="text" v-model="gameToEdit.backgroundUrl" />
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <!-- ThumbnailUrl -->
                                    <div class="field is-horizontal">
                                        <div class="field-label is-normal">
                                            <label class="label">Thumbnail url</label>
                                        </div>
                                        <div class="field-body">
                                            <div class="field">
                                                <div class="control">
                                                    <input class="input oc-input" type="text" v-model="gameToEdit.thumbnailUrl" />
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <!-- Category -->
                                    <div class="field is-horizontal">
                                        <div class="field-label is-normal">
                                            <label class="label">Category</label>
                                        </div>
                                        <div class="field-body">
                                            <div class="field">
                                                <div class="control">
                                                    <input class="input oc-input" type="text" v-model="gameToEdit.category" />
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="field is-horizontal">
                                        <div class="field-label">
                                            <!-- Left empty for spacing -->
                                        </div>
                                        <div class="field-body">
                                            <div class="field">
                                                <div class="control">
                                                    <button class="button is-primary" @click="edit(gameToEdit)">Save</button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </article>
                        </td>
                    </tr>
                </template>
            </tbody>
        </table>
    </div>
</template>
<script>
export default {
    name: 'aggregator-games-list',
    props: {
        provider: {
            type: String,
            required: true
        },
        save: {
            type: Function,
            required: true
        },
        edit: {
            type: Function,
            required: true
        },
        numOfGames: {
            type: Number,
            required: false
        },
        selectedFilter: {
            type: Object,
            required: false
        },
        loading: {
            type: Boolean,
            required: true
        }
    },
    data() {
        return {
            filter: 'all',
            games: [],
            gameToEdit: null,
            totalPages: 0
        };
    },
    computed: {
        clientId() {
            return Number(this.$route.params.clientId);
        },
        realIndex(){
            if(Number(this.$route.query.page) <= 0) this.$route.query.page = 1;
            return (Number(this.$route.query.page) - 1) * this.pageSize || 0;
        },
        pageSize(){
            return (Number(this.$route.query.size)) || this.games.length;
        },
        uiGames() {
            return this.games;
        }
    },
    methods: {
        async set(games) {
            this.games = games;
        },
        setGameToEdit(game) {
            this.gameToEdit = game;
        },
        changeFilter(filter){
            this.$emit('change-filter', filter);
        },
        toggleParametr(isEnable, param) {
            this.$emit('toggle-parametr', isEnable, param);
        },
        deleteFilter(option){
            this.$emit('delete-filter', option);
        }
    }
};
</script>
<style scoped lang="scss">
.thumbnail {
    max-width: 50px;
}
.toggle {
    cursor: pointer;
}
.field.has-addons{
    width: fit-content;
}
span.disabled{
    pointer-events: none;
    background-color: rgb(75, 75, 75);
}
</style>



// WEBPACK FOOTER //
// front/src/components/common/aggregator-games-list.vue